import React, { useEffect } from 'react';
import { Box } from '@drivekyte/web-components';
import 'intersection-observer';
import { useInView } from 'react-intersection-observer';
import SearchContent from './components/search-content';

export type SearchBoxProps = {
  onChangeVisibility?: (visibility: boolean) => void;
};

const SearchBox = ({ onChangeVisibility }: SearchBoxProps) => {
  const { ref, inView } = useInView({ initialInView: true });

  useEffect(() => {
    if (onChangeVisibility) {
      onChangeVisibility(inView);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  return (
    <Box ref={ref}>
      <SearchContent />
    </Box>
  );
};

export default SearchBox;
